import React from 'react';
import PropTypes from 'prop-types';
import { Trans } from 'react-i18next';
import colours from './Colours';
import Icon from './Icons/Icon';

// To change the button from inline-block to flex, include the following props: 
// <Button containerProps={{style: {display: 'flex' , flex: 1}}} style={{flex: 1}}/>

const Button = (props) => {

    let size = 'medium';
    let ic_size = 24;
    let variant = "primary";

    if (props.small === true) {
        size = 'small';
        ic_size = 16;
    } else if (props.large === true) {
        size = 'large'
    }
    if (props.secondary === true)
        variant = "secondary";
    if (props.tertiary === true)
        variant = "tertiary";

    if (variant === 'primary') {
        return (
            <div className="ds-button-container" {...props.containerProps}>
                <div 
                    onClick={props.disabled ? ()=> {} : props.onClick} 
                    className={"ds-button ds-button-primary ds-button-" + size + (props.disabled ? " ds-button-disabled" : "") + (props.red ? " red" : "")}
                    style={props.style ? props.style : props.color ? {backgroundColor: props.color} : undefined}
                    >
                        {props.leading_ic ? 
                            <div className="ds-button-leading-ic">
                                <Icon name={props.leading_ic} size={ic_size} style={props.color ? {color: props.color} : {color: colours.primary.white}}/>
                            </div> 
                        : null}
                        <Trans>{props.label}</Trans>
                        {props.trailing_ic ? 
                            <div className="ds-button-trailing-ic">
                                <Icon name={props.trailing_ic} size={ic_size} style={props.color ? {color: props.color} : {color: colours.primary.white}}/>
                            </div> 
                        : null}
                </div>
            </div>
        )
    } else if (variant === 'secondary') {
        return (
            <div className="ds-button-container" {...props.containerProps}>
                <div 
                    onClick={props.disabled ? ()=> {} : props.onClick} 
                    className={"ds-button ds-button-secondary ds-button-" + size + (props.disabled ? " ds-button-disabled" : "") + (props.red ? " red" : "")}
                    style={props.style ? props.style : props.color ? {color: props.color, borderColor: props.color} : undefined}
                    >
                        {props.leading_ic ? 
                            <div className="ds-button-leading-ic">
                                <Icon name={props.leading_ic} size={ic_size} class='primary' style={props.color ? {color: props.color} : null}/>
                            </div> 
                        : null}
                        <Trans>{props.label}</Trans>
                        {props.trailing_ic ? 
                            <div className="ds-button-trailing-ic">
                                <Icon name={props.trailing_ic} size={ic_size} class='primary' style={props.color ? {color: props.color} : null}/>
                            </div> 
                        : null}
                </div>
            </div>
        )
    } else if (variant === 'tertiary') {
        return (
            <div className="ds-button-container" {...props.containerProps}>
                <div 
                    onClick={props.disabled ? ()=> {} : props.onClick}
                    className={"ds-button ds-button-tertiary primary ds-button-" + size + (props.disabled ? " ds-button-disabled" : "") + (props.red ? " red" : "")}
                    style={props.style ? props.style : props.color ? {color: props.color} : undefined}
                    >
                        {props.leading_ic ? 
                            <div className="ds-button-leading-ic">
                                <Icon name={props.leading_ic} size={ic_size} class='primary' style={props.color ? {color: props.color} : null}/>
                            </div> 
                        : null}
                        <Trans>{props.label}</Trans>
                        {props.trailing_ic ? 
                            <div className="ds-button-trailing-ic">
                                <Icon name={props.trailing_ic} size={ic_size} class='primary' style={props.color ? {color: props.color} : null}/>
                            </div> 
                        : null}
                </div>
            </div>
        )
    }
}

Button.defaultProps = {
    small: false,
    medium: false,
    large: false,
    primary: false,
    secondary: false,
    tertiary: false,
    label: '',
    color: '',
    red: false,
    leading_ic: '',
    trailing_ic: '',
    onClick: null,
    containerProps: null,
    disabled: false
};

Button.propTypes = {
    small: PropTypes.bool,
    medium: PropTypes.bool,
    large: PropTypes.bool,
    primary: PropTypes.bool,
    secondary: PropTypes.bool,
    tertiary: PropTypes.bool,
    label: PropTypes.string.isRequired,
    color: PropTypes.string,
    red: PropTypes.bool,
    leading_ic: PropTypes.string,
    trailing_ic: PropTypes.string,
    onClick: PropTypes.func,
    containerProps: PropTypes.object,
    disabled: PropTypes.bool
}

export default Button;